import Vue from 'vue'
import Router from 'vue-router'
import { SITE_PAGE_DEFINITIONS } from '@/constants/sitePages'
import { scrollPageToTop } from '@/utils/pageNavigation'
import { isLoggedIn } from '@/utils/auth'
import store from './store'

Vue.use(Router)

const sitePageRoutes = SITE_PAGE_DEFINITIONS.map(item => ({
  path: item.path,
  name: `site-page-${item.key}`,
  component: () => import('./views/SitePage.vue'),
  meta: { sitePageKey: item.key }
}))

const router = new Router({
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return new Promise(resolve => {
      Vue.nextTick(() => {
        scrollPageToTop()
        resolve({ x: 0, y: 0 })
      })
    })
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/search',
      name: 'trademark-search',
      component: () => import('./views/TrademarkSearch.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/TrademarkRegister.vue')
    },
    {
      path: '/objection',
      name: 'objection',
      component: () => import('./views/TrademarkObjection.vue')
    },
    {
      path: '/news',
      name: 'news-list',
      component: () => import('./views/NewsList.vue')
    },
    {
      path: '/news/:id',
      name: 'news-detail',
      component: () => import('./views/NewsDetail.vue')
    },
    {
      path: '/detail/:id',
      name: 'trademark-detail',
      component: () => import('./views/TrademarkDetail.vue')
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
      meta: { public: true }
    },
    {
      path: '/order',
      name: 'trademark-order',
      component: () => import('./views/TrademarkOrder.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/my-orders',
      name: 'my-orders',
      component: () => import('./views/MyOrders.vue'),
      meta: { requiresAuth: true }
    },
    ...sitePageRoutes
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.public) {
    next()
    return
  }

  if (to.meta && to.meta.requiresAuth && !isLoggedIn()) {
    store.commit('SHOW_LOGIN', to.fullPath)
    if (from.path && from.path !== to.path) {
      next(false)
    } else {
      next('/')
    }
    return
  }

  next()
})

export default router
